module.exports = __webpack_public_path__ + "static/media/rm_06-32.c00a866f.png";